import { render } from "./SaveVoicePopup.vue?vue&type=template&id=0769bcf9&scoped=true"
import script from "./SaveVoicePopup.vue?vue&type=script&lang=js"
export * from "./SaveVoicePopup.vue?vue&type=script&lang=js"

import "./SaveVoicePopup.vue?vue&type=style&index=0&id=0769bcf9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0769bcf9"]])

export default __exports__